import { WebLink } from '@news-mono/web-common'
import React from 'react'
import { TheWestLetsGoTokyoLogo } from '../../../logos/TheWestLetsGoTokyo/TheWestLetsGoTokyo'
import { ThemeOverrider } from '../../../themes/ThemeOverrider/ThemeOverrider'
import { StyledSidebarHeader } from './SidebarHeader.styled'

export function SidebarHeader() {
    return (
        <ThemeOverrider override="tokyo">
            <StyledSidebarHeader>
                <WebLink to="/sport/olympics">
                    <TheWestLetsGoTokyoLogo />
                </WebLink>
            </StyledSidebarHeader>
        </ThemeOverrider>
    )
}
